import {
    spaceSmall,
    spaceMedium,
    spaceLarge,
    radiusNano,
} from '@ui/styles/spaces';
import { pureWhite } from '@ui/styles/colors';

export const nestedListItemLegendFormFieldRecapStyle = {
    display: 'block',
};

export const recapCardContentStyle = {
    paddingLeft   : spaceSmall,
    paddingRight  : spaceSmall,
    paddingTop    : spaceSmall,
    paddingBottom : spaceSmall,
};

export const recapImageStyle = {
    width          : '100%',
    minHeight      : '200px',
    objectFit      : 'cover' as 'cover',
    objectPosition : '50% 50%',
    borderRadius   : radiusNano,
    overflow       : 'hidden' as 'hidden',
};

export const recapItemLabelStyle = {
    opacity: 0.5,
};

export const recapAvatarStyle = {
    backgroundColor : pureWhite,
    borderRadius    : radiusNano,
};

export const recapItemListItemStyle = {
    paddingTop    : 0,
    paddingBottom : 0,
};

export const recapGridItemStyle = {
    display       : 'flex',
    flexDirection : 'column' as 'column',
    flexGrow      : 1,
};

export const recapGridItemFormFlowStyle = {
    display  : 'flex',
    flexGrow : 1,
};

export const recapCardStyle = {
    flexGrow: 1,
};

export const recapImageCardStyle = {
    alignContent : 'center',
    color        : 'red',
};

export const recapItemListItemTextStyle = {
    marginTop    : 0,
    marginBottom : 0,
};

export const recapGridContainerStyle = {
    marginTop    : spaceMedium,
    marginBottom : spaceLarge,
};

export const pdfLinkStyle = {
    color: pureWhite,
};

export const pdfFabStyle = {
    position : 'absolute' as 'absolute',
    bottom   : spaceSmall,
    right    : spaceSmall,
};

export const imageWrapperStyle = {
    position   : 'relative' as 'relative',
    paddingTop : spaceSmall,
};

export const titleStyle = {
    textAlign: 'center' as 'center',

    '@media screen and (max-width: 700px)': {
        textAlign: 'left' as 'left',
    },
};

export const recapGridContainerFormFlowStyle = {
    alignContent : 'space-around',
    marginTop    : 0,
    marginBottom : 0,
};
